import api from '@pray/shared/utils/api';

export type CompleteMarketingCampaignParams = {
  artistId: string;
  campaignId: string;
};

export const completeMarketingCampaign = async ({ artistId, campaignId }: CompleteMarketingCampaignParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}/complete`;

  const response = await api.executePostRequest(url, {});

  return response.data;
};
